
import approvals from './approvals' // 审批管理
import vehicle from './vehicle' // 车辆
import finance from './finance' // 财务
import carsService from './carsService' // 车务
import customers from './customers' // 客户
import orders from './orders' // 订单
import others from './others'// 待划分领域
import workbench from './workbench' // 数据看板
import purchase from './purchase' // 采购
import company from './company' // 公司
import underLease from './underLease' // 租赁中
import group from './group' // 集团
import driver from './driver' // 司机
import waitForRent from './waitForRent' // 待租
import returnLease from './returnLease' // 退租
import logs from './logs' // 日志

// 历史路由
import moduleRouters from '../modules'

const domainRouter = [
  approvals,
  vehicle,
  carsService,
  finance,
  customers,
  orders,
  workbench,
  others,
  purchase,
  company,
  underLease,
  group,
  driver,
  waitForRent,
  returnLease,
  logs,
  ...moduleRouters,
]

export default domainRouter
